module.exports = __webpack_public_path__ + "static/assets/f39732f1e8e48780968949221a8cfaf7.gif";